import { call, put, takeEvery } from 'redux-saga/effects'
import { OK } from '@/constants/utils'

import {
  sendExpertVisitRequest,
  sendExpertComment,
  sendExpertMessage,
  sendProspectVisitRequest,
  sendProspectWaitingList,
} from '@/store/experts'
import { notificationsCreate } from '@/store/notifications'
import { NOTIFICATIONS, ToastKind } from '@/constants'
import partnersApi from '@/apis/partners'

export function* requestExpertMessage({
  payload: {
    id,
    values: { email, userEmail, message, name, surname, website },
  },
}) {
  try {
    const { status } = yield call(partnersApi.sendExpertMessage, {
      id,
      email,
      userEmail,
      message,
      name,
      surname,
      website,
    })

    if (status === OK) {
      yield put(
        sendExpertMessage.fulfilled({
          id,
        })
      )
      yield put(
        notificationsCreate({
          kind: ToastKind.Success,
          content: 'Message sent successfully!',
          autoHideDelayTime: NOTIFICATIONS.AUTO_HIDE_DELAY_TIME,
        })
      )
    } else {
      throw new Error("Expert request couldn't be sent")
    }
  } catch (error) {
    yield put(
      notificationsCreate({
        kind: ToastKind.Error,
        content: "We couldn't send the expert request",
        autoHideDelayTime: NOTIFICATIONS.AUTO_HIDE_DELAY_TIME,
      })
    )
    yield put(sendExpertMessage.rejected({ error: error?.message }))
  }
}

export function* requestExpertComment({
  payload: {
    id,
    values: { email, userEmail, review, name, website },
  },
}) {
  try {
    const { status } = yield call(partnersApi.sendExpertComment, {
      id,
      email,
      userEmail,
      review,
      name,
      website,
    })

    if (status === OK) {
      yield put(sendExpertComment.fulfilled({ id }))
      yield put(
        notificationsCreate({
          kind: ToastKind.Success,
          content: 'Review sent to be verified!',
          autoHideDelayTime: NOTIFICATIONS.AUTO_HIDE_DELAY_TIME,
        })
      )
    } else if (status === 409) {
      yield put(
        sendExpertComment.rejected({ error: 'Review has been already sent!' })
      )

      yield put(
        notificationsCreate({
          kind: ToastKind.Warning,
          content: 'Review had already been sent!',
          autoHideDelayTime: NOTIFICATIONS.AUTO_HIDE_DELAY_TIME,
        })
      )
    } else {
      throw new Error("Expert review couldn't be sent")
    }
  } catch (error) {
    yield put(
      notificationsCreate({
        kind: ToastKind.Error,
        content: "Expert review couldn't be sent",
        autoHideDelayTime: NOTIFICATIONS.AUTO_HIDE_DELAY_TIME,
      })
    )
    yield put(sendExpertComment.rejected({ error: error?.message }))
  }
}

export function* sendExpertVisit({ payload: { id } }) {
  try {
    yield call(partnersApi.sendExpertVisit, { id })
  } catch (err) {}
}

export function* sendProspectVisit({ payload: { id } }) {
  try {
    yield call(partnersApi.sendProspectVisit, { id })
  } catch (err) {}
}

export function* requestProspectWaitingList({
  payload: {
    id,
    values: { email },
  },
}) {
  try {
    const { status } = yield call(partnersApi.sendProspectWaitingList, {
      id,
      email,
    })
    if (status === OK) {
      yield put(
        sendProspectWaitingList.fulfilled({
          id,
        })
      )
    } else {
      throw new Error("Contact request couldn't be sent")
    }
  } catch (error) {
    yield put(
      notificationsCreate({
        kind: ToastKind.Error,
        content: "We couldn't send the contact request",
        autoHideDelayTime: NOTIFICATIONS.AUTO_HIDE_DELAY_TIME,
      })
    )
    yield put(sendProspectWaitingList.rejected({ error: error?.message }))
  }
}

export function* watchExpertsRequests() {
  yield takeEvery(sendExpertMessage.pending, requestExpertMessage)
  yield takeEvery(sendExpertComment.pending, requestExpertComment)
  yield takeEvery(sendExpertVisitRequest, sendExpertVisit)
  yield takeEvery(sendProspectVisitRequest, sendProspectVisit)
  yield takeEvery(sendProspectWaitingList.pending, requestProspectWaitingList)
}
